export type CriteriaType = 'user_timespent_event' | 'poll_responses' | 'qna' | 'in_app_survey' | 'resources';

export type RequirementType = 'at_least' | 'exactly';

export interface Criteria {
  type: CriteriaType | '';
  requirement: RequirementType;
  value: string;
}

export interface SelectOption {
  value: string;
  label: string;
}

export interface Session {
  id: string;
  name: string;
}

export interface Rule {
  criteria: Criteria[];
  creditAmount: string;
  sessions: string[];
}

export interface RuleSetFormData {
  rules: Rule[];
  certificate: string;
  emailDesign: string;
}

export interface Certificate {
  id: string;
  name: string;
  createdDate: string;
}

export enum CreditRuleRequestFor {
  Event = 'event',
  Template = 'template',
  None = ''
}

export interface StepNavItem {
  label: string;
}

export function createDefaultCriteria(): Criteria {
  return { type: '', requirement: 'at_least', value: '' };
}

export function createDefaultRule(): Rule {
  return { criteria: [createDefaultCriteria()], creditAmount: '', sessions: [] };
}

export const CRITERIA_LABELS: Record<CriteriaType, string> = {
  user_timespent_event: 'Live Time Spent',
  poll_responses: 'Polls Answered',
  qna: 'Questions Asked',
  in_app_survey: 'Surveys Submitted',
  resources: 'Resources Clicked'
};

export const REQUIREMENT_LABELS: Record<RequirementType, string> = {
  at_least: 'At least',
  exactly: 'Exactly'
};

// TODO: Replace with API-backed lookup once certificates are fetched from the server
export const CERTIFICATE_NAMES: Record<string, string> = {
  'prof-dev': 'Professional Development',
  'cont-ed': 'Continuing Education',
  'webinar-comp': 'Webinar Completion'
};

export function criteriaLabel(type: CriteriaType | ''): string {
  return type ? CRITERIA_LABELS[type] : '';
}

export function requirementLabel(requirement: RequirementType): string {
  return REQUIREMENT_LABELS[requirement];
}

export function criteriaValueLabel(type: CriteriaType | '', value: string): string {
  if (type === 'user_timespent_event') {
    return `${value} min`;
  }
  return value;
}

export function certificateNameLabel(certificate: string): string {
  return CERTIFICATE_NAMES[certificate] || certificate;
}

export function emailDesignNameLabel(emailDesign: string, templates: { id: string; name: string }[]): string {
  return templates.find(t => t.id === emailDesign)?.name || emailDesign;
}
